import { useState, useEffect } from "react";
import ThemeMaker from "../../components/thememaker";
import axios from "axios";
import { config } from "../../utils/config";
import { useHistory } from "react-router-dom";
import moment from "moment";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

export default function GrievanceList() {
  const { apiEndpoint } = config;
  const history = useHistory();
  const [listData, setListData] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchGrievanceList();
  }, []);

  async function fetchGrievanceList() {
    setLoading(true);
    try {
      const { data } = await axios({
        url: `${apiEndpoint}/snp/igm/getallgrodetails`,
        method: "GET",
        headers: {
          "x-custom-authorization": `Bearer ${sessionStorage.getItem("token")}`,
        }
      });
      const details = data?.data || data?.igmDetails || [];
      if (Array.isArray(details)) {
        setListData(details);
      } else if (details && typeof details === "object" && Object.keys(details).length > 0) {
        setListData([details]);
      } else {
        setListData([]);
      }
    } catch (err) {
      console.error("Error fetching grievance list:", err);
    } finally {
      setLoading(false);
    }
  }

  return (
    <ThemeMaker>
      <div className="row w-100 m-0 mt-1">
        <div className="col-md-12">
          <div className="card shadow mb-4">
            <div className="card-header py-3 d-flex justify-content-between align-items-center">
              <div className="d-flex align-items-center" style={{ gap: "12px" }}>
                <span
                  style={{ cursor: "pointer" }}
                  onClick={() => history.push("/grievancesettings")}
                  className="btn btn-primary btn-sm d-flex align-items-center justify-content-center p-2"
                  title="Back"
                >
                  <ArrowBackIcon />
                </span>
                <h6 className="m-0 font-weight-bold text-primary">All Grievance List</h6>
              </div>
            </div>
            <div className="card-body" style={{ minHeight: "70vh" }}>
              {loading ? (
                <div className="text-center py-5">
                  <div className="spinner-border text-primary" role="status">
                    <span className="sr-only">Loading...</span>
                  </div>
                </div>
              ) : (
                <div className="table-responsive">
                  <table className="table table-bordered table-striped table-hover">
                    <thead className="thead-light">
                      <tr>
                        <th>#</th>
                        <th>Organization Name</th>
                        <th>Organization Email</th>
                        <th>Contact Number</th>
                        <th>Created At</th>
                      </tr>
                    </thead>
                    <tbody>
                      {listData && listData.length > 0 ? (
                        listData.map((item: any, idx: number) => (
                          <tr key={idx}>
                            <td>{idx + 1}</td>
                            <td>{item.org_person_name || item.name || "-"}</td>
                            <td>{item.org_email || item.email || "-"}</td>
                            <td>{item.org_phone || item.number || "-"}</td>
                            <td>{item.created_at ? moment(item.created_at).format("DD MMM YYYY, hh:mm A") : "-"}</td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan={5} className="text-center py-4 text-muted">
                            No records found
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </ThemeMaker>
  );
}
